import { FC } from 'react'

import { ISvgClass } from '../interface'

const SecondCopyIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M12.5 2.38464V8.15387C12.5 8.5619 12.658 8.95321 12.9393 9.24173C13.2206 9.53025 13.6022 9.69234 14 9.69234H19.625M8.75 13.5385H16.25M8.75 17.3846H16.25M20 10.3293V19.6923C20 20.3043 19.7629 20.8913 19.341 21.3241C18.919 21.7569 18.3467 22 17.75 22H7.25C6.65326 22 6.08097 21.7569 5.65901 21.3241C5.23705 20.8913 5 20.3043 5 19.6923V4.30769C5 3.69565 5.23705 3.10868 5.65901 2.67591C6.08097 2.24313 6.65326 2 7.25 2H11.8789C12.2766 2.00006 12.658 2.1621 12.9392 2.45048L19.5608 9.24183C19.842 9.53028 19.9999 9.92144 20 10.3293Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linejoin="round"
        fill="inherit"
      />
    </svg>
  )
}

export default SecondCopyIcon
